"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6104],{

/***/ 55417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": function() { return /* binding */ GetPriceListReplacements; },
/* harmony export */   "I3": function() { return /* binding */ getWarrantyExtensions; },
/* harmony export */   "JU": function() { return /* binding */ getServiceInstructions; },
/* harmony export */   "iz": function() { return /* binding */ getRecalls; },
/* harmony export */   "mK": function() { return /* binding */ getColorCodes; }
/* harmony export */ });
/* unused harmony export getWarrantyExtensionsTopTable */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
var brandId = 1 // mazda
;
var host = "https://serviceforms.delek-motors.co.il/Home";

var getRecalls = function(data, selected) {
    var param = selected === "licenseNumber" ? "licenseNumber" : "chassis";
    var uri = "".concat(host, "/GetRecalls?brandId=").concat(brandId, "&").concat(param, "=").concat(data);
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(uri);
};
var getServiceInstructions = function(data, selected) {
    var param = selected === "licenseNumber" ? "licenseNumber" : "chassis";
    var uri = "".concat(host, "/GetServiceInstructions?brandId=").concat(brandId, "&").concat(param, "=").concat(data);
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(uri);
};
var getColorCodes = function(data, selected) {
    var param = selected === "licenseNumber" ? "licenseNumber" : "chassis";
    var uri = "".concat(host, "/GetColorCodes?brandId=").concat(brandId, "&").concat(param, "=").concat(data);
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(uri);
};
var getWarrantyExtensionsTopTable = function() {
    var uri = "".concat(host, "/GetWarrantyExtensionsTopTable?brandId=").concat(brandId);
    return axios.get(uri, {
        timeout: 10000
    });
};
var getWarrantyExtensions = function(data, selected) {
    var param = selected === "licenseNumber" ? "licenseNumber" : "chassis";
    var uri = "".concat(host, "/GetWarrantyExtensions?brandId=").concat(brandId, "&").concat(param, "=").concat(data);
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(uri);
};
var GetPriceListReplacements = function(data, param) {
    data = data.trim();
    var uri = "".concat(host, "/GetPriceListReplacements?brandId=").concat(brandId, "&").concat(param, "=").concat(data);
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(uri);
};


/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 74962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* display: flex; */\n  /* flex-wrap: wrap; */\n  /* gap: ",
        "px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 44px;\n  border: solid 1px transparent;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  background-color: ",
        ";\n  font-size: 16px;\n  direction: ",
        ";\n  cursor: pointer;\n  position: relative;\n  ",
        "\n\n  @media print {\n    display: none;\n    justify-content: flex-start;\n    box-shadow: none;\n    background-image: none !important;\n\n    span {\n      justify-content: flex-start;\n    }\n  }\n\n  b {\n    font-size: 1.5em;\n  }\n\n  span {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    inset: 0;\n    line-height: 1;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  border: 0;\n  margin: -1px;\n  padding: 0;\n  border-radius: 50%;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n\n  &:focus-visible + label {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n\n  :checked + ",
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n\n  :focus + ',
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SingleButtonSelection__StyledContainer",
    componentId: "sc-f3a656e3-0"
})(_templateObject(), function(props) {
    return props.$gap;
});
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    displayName: "SingleButtonSelection__StyledButtonWrap",
    componentId: "sc-f3a656e3-1"
})(_templateObject1(), function(props) {
    return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "SingleButtonSelection__StyledLabel",
    componentId: "sc-f3a656e3-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$isBattery ? "ltr" : "rtl";
}, function(p) {
    return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function(p) {
    return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "SingleButtonSelection__StyledRadio",
    componentId: "sc-f3a656e3-3"
})(_templateObject3(), StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var SingleButtonSelection = function(param) {
    var id = param.id, // title,
    items = param.items, onSelect = param.onSelect, isBattery = param.isBattery, customButton = param.customButton, // headlineComponent,
    selectedValue = param.selectedValue, className = param.className, _itemsPerRow = param.itemsPerRow, itemsPerRow = _itemsPerRow === void 0 ? 2 : _itemsPerRow, _gap = param.gap, gap = _gap === void 0 ? 0 : _gap;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(selectedValue || items[0].value), selectedButton = ref[0], setSelectedButton = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!items || !items.length) {
            return;
        }
        setSelectedButton(selectedValue || items[0].value);
    }, [
        items,
        selectedValue
    ]);
    var handleChange = function(value, index) {
        setSelectedButton(value);
        onSelect(value, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
        role: "radiogroup",
        "aria-labelledby": id,
        $gap: gap,
        className: className,
        children: items.map(function(item, index) {
            var ref;
            var radioId = "radio_".concat(id, "_").concat(item.value);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
                tabIndex: -1,
                role: "presentation",
                focusRipple: true,
                $itemsPerRow: itemsPerRow,
                $gap: gap,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
                        "aria-label": "כפתור רדיו",
                        type: "radio",
                        name: id,
                        value: item.value,
                        id: radioId,
                        checked: item.value === selectedButton,
                        // disabled={!color.details.inStock}
                        onChange: function() {
                            handleChange(item.value, index);
                            setSelectedButton(item.value);
                        }
                    }),
                    customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
                        $isBattery: isBattery,
                        htmlFor: radioId,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                            children: [
                                item.secondaryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                                    children: [
                                        item.secondaryName.toUpperCase(),
                                        "\xa0"
                                    ]
                                }),
                                (ref = item.name) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                            ]
                        })
                    })
                ]
            }, "".concat(id, "-").concat(item.value, "-").concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SingleButtonSelection));


/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73192);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_3__.Form).withConfig({
    displayName: "FormikForm__StyledForm",
    componentId: "sc-1cd63cac-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
function FormikForm(param) {
    var validationSchema = param.validationSchema, initialValues = param.initialValues, render = param.render, onSubmit = param.onSubmit, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__.Formik, {
        innerRef: innerRef,
        initialValues: initialValues,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(values, actions) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            actions.setSubmitting(true);
                            return [
                                4,
                                onSubmit(values, actions)
                            ];
                        case 1:
                            _state.sent();
                            actions.setSubmitting(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, actions) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(formik) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledForm, {
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__.ConnectedFocusError, {}),
                    render(formik)
                ]
            });
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormikForm);


/***/ }),

/***/ 11852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var formik_material_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24065);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    .MuiFormHelperText-root.Mui-error {\n      ",
        "\n    }\n    input {\n      color: ",
        ';\n      font-family: "OENaPro";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 140%;\n      ',
        "\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Styled = {
    Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_2__.Field).withConfig({
        displayName: "FormikInput__Field",
        componentId: "sc-ca467ef3-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hideLabel) && "label { display: none; }";
    }, function(p) {
        return p.$center ? "text-align: center;" : "";
    }, function(p) {
        return p.theme.colors.black;
    }, function(p) {
        return p.$center ? "text-align: center;" : "";
    })
};
var FormikInput = function(_param) {
    var name = _param.name, label = _param.label, _type = _param.type, type = _type === void 0 ? "text" : _type, _required = _param.required, required = _required === void 0 ? false : _required, placeholder = _param.placeholder, maxLength = _param.maxLength, numeric = _param.numeric, InputProps = _param.InputProps, centerField = _param.centerField, autoFocus = _param.autoFocus, className = _param.className, hideLabel = _param.hideLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "name",
        "label",
        "type",
        "required",
        "placeholder",
        "maxLength",
        "numeric",
        "InputProps",
        "centerField",
        "autoFocus",
        "className",
        "hideLabel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Styled.Field, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        $center: centerField,
        $hideLabel: hideLabel,
        label: label,
        component: formik_material_ui__WEBPACK_IMPORTED_MODULE_3__/* .TextField */ .nv,
        id: name,
        name: name,
        type: type,
        required: required,
        helperText: " ",
        placeholder: placeholder,
        inputProps: {
            maxLength: maxLength,
            inputMode: numeric && "numeric",
            pattern: numeric && "[0-9]*"
        },
        InputProps: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, InputProps),
        autoFocus: autoFocus,
        variant: "outlined",
        className: className
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikInput);


/***/ }),

/***/ 46363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Cr": function() { return /* binding */ schemaCommon; },
/* harmony export */   "Sz": function() { return /* binding */ regex; }
/* harmony export */ });
/* unused harmony exports max, invalid */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var max = {
    fullname: [
        50,
        "ניתן להזין עד 50 תווים"
    ]
};
var required = {
    default: "שדה זה הינו שדה חובה",
    firstName: "יש להזין שם פרטי",
    lastName: "יש להזין שם משפחה",
    phoneNumber: "יש להזין מספר טלפון",
    licenseNumber: "יש להזין לוחית רישוי",
    licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
    modelId: "בחר דגם",
    area: "בחר איזור",
    skuOrName: "נא הכנס טקסט חופשי או מספר פריט"
};
var regex = {
    numbersAndLetters: /^[a-zA-Zא-תא-ת0-9 ]+$/,
    numbers: /^[0-9]*$/,
    singleName: /^[a-zA-Zא-ת ״\-,.׳]+$/,
    fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
    name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
    phoneNumber: /^05\d([-]{0,1})\d{7}$/,
    licenseNumber: /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
    licenceOrChassis: /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/
};
var invalid = {
    numbers: "יש להזין ספרות בלבד",
    numbersShort: "ספרות בלבד",
    numbersAndLetters: "ספרות ואותיות",
    fullName: "שם מלא לא תקין",
    name: "יש להזין אותיות בעברית / אנגלית בלבד",
    email: "כתובת המייל אינה תקינה",
    phoneNumber: "מספר הטלפון אינו תקין",
    licenseNumber: "לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות שמורכב מספרות בלבד",
    licenceOrChassis: "מספר רישוי או שילדה לא תקין"
};
var schemaCommon = {
    phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.phoneNumber, "עד 10 ספרות, ללא מקף").length(10, "עד 10 ספרות, ללא מקף").required("עד 10 ספרות, ללא מקף").max(10, "עד 10 ספרות, ללא מקף"),
    firstName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    lastName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    fullName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.fullName, "שם מלא בבקשה :)").max(100, "יש להזין עד 100 תווים בלבד").required(required.default),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("כתובת המייל לא תקינה").required(required.default),
    city: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    street: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    apartmentNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    floorNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    entranceNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbersAndLetters, invalid.numbersAndLetters),
    comments: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(200, "ניתן להזין עד 200 תווים"),
    termsOfUseCheckbox: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "יש לאשר את תנאי השימוש"),
    onlyNumbers: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    organization: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    organizationTitle: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    checkboxRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "שדה חובה"),
    checkboxNotRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().defined(),
    licenseNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות ברצף וללא מקף").matches(regex.licenseNumber, invalid.licenseNumber),
    chassis: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("מספר שילדה אינו תקין"),
    catalog: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(required.default)
};


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 97294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ StyledHeaderSubtitle; },
/* harmony export */   "$v": function() { return /* binding */ StyledTh; },
/* harmony export */   "EF": function() { return /* binding */ StyledLi; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "GI": function() { return /* binding */ StyledTd; },
/* harmony export */   "PW": function() { return /* binding */ StyledSmallText; },
/* harmony export */   "SG": function() { return /* binding */ StyledThead; },
/* harmony export */   "TK": function() { return /* binding */ StyledSubtitle; },
/* harmony export */   "ZN": function() { return /* binding */ StyledBody2; },
/* harmony export */   "aG": function() { return /* binding */ StyledTr; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "hc": function() { return /* binding */ StyledUl; },
/* harmony export */   "k6": function() { return /* binding */ StyledTable; },
/* harmony export */   "vc": function() { return /* binding */ StyledBody; },
/* harmony export */   "x0": function() { return /* binding */ StyledHeaderH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "px;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 40px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  &::marker {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  ",
        ";\n  color: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    display: block;\n    width: ",
        ";\n    overflow: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: normal;\n  td:first-child {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 7px 7px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: normal;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 5px;\n  border: 1px solid ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var StyledHeaderH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "BodyText__StyledHeaderH2",
    componentId: "sc-971327b-0"
})(_templateObject(), function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "24px";
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "400";
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSubtitle",
    componentId: "sc-971327b-1"
})(_templateObject1(), function(p) {
    return p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledHeaderSubtitle",
    componentId: "sc-971327b-2"
})(_templateObject2(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "20px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
});
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BodyText__StyledBody",
    componentId: "sc-971327b-3"
})(_templateObject3(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "18px";
});
var StyledH3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledH3",
    componentId: "sc-971327b-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUl = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "BodyText__StyledUl",
    componentId: "sc-971327b-5"
})(_templateObject5(), function(p) {
    return p.$padding && "padding-right: ".concat(p.$padding, "px");
});
var StyledLi = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "BodyText__StyledLi",
    componentId: "sc-971327b-6"
})(_templateObject6(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0px";
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "BodyText__StyledLink",
    componentId: "sc-971327b-7"
})(_templateObject7(), function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
}, function(p) {
    return p.$color ? p.$color : p.theme.colors.mazdaRed;
}, function(p) {
    return p.$display && "display: ".concat(p.$display);
}, function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
});
var StyledSmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSmallText",
    componentId: "sc-971327b-8"
})(_templateObject8(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$fontWeight && "font-weight: ".concat(p.$fontWeight);
});
var StyledBody2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BodyText__StyledBody2",
    componentId: "sc-971327b-9"
})(_templateObject9(), function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "BodyText__StyledTable",
    componentId: "sc-971327b-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$width ? p.$width : "350px";
}, function(p) {
    return p.theme.breakpoints.down("xs");
}, function(p) {
    return p.$width ? p.$width : "90vw";
});
var StyledThead = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
    displayName: "BodyText__StyledThead",
    componentId: "sc-971327b-11"
})(_templateObject11());
var StyledTr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    displayName: "BodyText__StyledTr",
    componentId: "sc-971327b-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "BodyText__StyledTh",
    componentId: "sc-971327b-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    displayName: "BodyText__StyledTd",
    componentId: "sc-971327b-14"
})(_templateObject14(), function(p) {
    return p.theme.colors.darkGrey;
});


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ })

}]);